import { render } from "./aio-login-popup.vue?vue&type=template&id=4646605c&scoped=true"
import script from "./aio-login-popup.vue?vue&type=script&lang=js"
export * from "./aio-login-popup.vue?vue&type=script&lang=js"

import "./aio-login-popup.vue?vue&type=style&index=0&id=4646605c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4646605c"]])

export default __exports__